/**
 * 格式化日期适配ios及安卓设备
 * @param {*} date 
 */
function GetDateDiff(date) {
  if (date) {
    return date.replace(/\-/g, "/");
  }
};

function filtDate(val) {
  var today = new Date().getTime();
  var oldTime = new Date(GetDateDiff(val)).getTime();
  var limit = today - oldTime;
  var content = "";
  if (limit < 60000) {
    content = "刚刚";
  } else if (limit >= 60000 && limit < 3600000) {
    content = Math.floor(limit / 60000) + "分钟前";
  } else if (limit >= 3600000 && limit < 86400000) {
    content = Math.floor(limit / 3600000) + "小时前";
  } else if (limit >= 86400 && limit < 172800000) {
    content = "昨天";
  } else if (limit >= 172800000 && limit < 2592000000) {
    content = Math.floor(limit / 86400000) + "天前";
  } else if (limit >= 2592000000 && limit < 31104000000) {
    content = Math.floor(limit / 2592000000) + "个月前";
  } else {
    content = "很久前";
  }
  return content;
}


export const Filters = {
  filtDate: filtDate
}



// WEBPACK FOOTER //
// ./src/common/filters.js